// src/components/strumenti/ConversioneWhAh.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConversioneWhAh() {
  const [modo, setModo] = useState("wh_ah");
  const [valore, setValore] = useState("");
  const [tensione, setTensione] = useState("12");

  const v = leggiNumero(valore)||0;
  const V = leggiNumero(tensione)||0;
  const risultato = V>0 ? (modo==="wh_ah" ? v/V : v*V) : null;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("wh_ah");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="wh_ah"?"#7c3aed":"#e5e7eb"}`, background: modo==="wh_ah"?"#faf5ff":"#fff", color: modo==="wh_ah"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Wh → Ah</button>
        <button onClick={()=>{setModo("ah_wh");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="ah_wh"?"#7c3aed":"#e5e7eb"}`, background: modo==="ah_wh"?"#faf5ff":"#fff", color: modo==="ah_wh"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Ah → Wh</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>{modo==="wh_ah" ? "Energia (Wh)" : "Capacità (Ah)"}</label>
          <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder="Es. 100"/>
        </div>
        <div>
          <label style={lbl}>Tensione (V)</label>
          <input value={tensione} onChange={e=>setTensione(e.target.value)} style={inp}/>
        </div>
      </div>

      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{modo==="wh_ah" ? "Capacità" : "Energia"}</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#7c3aed" }}>
          {risultato===null || isNaN(risultato) ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:2})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="wh_ah" ? "Ah" : "Wh"}</span>
        </div>
      </div>

      <button onClick={()=>{setValore("");setTensione("12");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
